import type { ReactNode } from 'react'
import React from 'react'
import { HorizontalStack } from '../HorizontalStack'
import { Icon } from '../Icon'
import { TooltipPopOver } from '../TooltipPopOver'

export type IconValueBlockProps = {
  children?: ReactNode
  icon: string
  value?: ReactNode
  help?: string
  className?: string
}
export const IconValueBlock = ({ children, icon, value, help, className }: IconValueBlockProps) => {
  return (
    <HorizontalStack gap={1} className="align-items-start">
      <div>
        <Icon name={icon} className={className} />
      </div>
      <div>
        <TooltipPopOver tooltipBody={help}>
          <div>{value || children}</div>
        </TooltipPopOver>
      </div>
    </HorizontalStack>
  )
}
